export default __webpack_public_path__ + "static/media/passenger-source.38e32838.png";